// extracted by mini-css-extract-plugin
export default {"ball":"ttnZiDpTV0reSms5hcLC","screenSaver":"MWURAxPCPtiLgtmpYLCy"};